import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal, inject } from '@angular/core';
import { FaqDrill, FaqItem } from '@coin/shared/core/util-models';
import { AuthService } from '@coin/shared/auth/data-access';
import { NgStyle } from '@angular/common';
import { MatBadge } from '@angular/material/badge';
import { MatIcon } from '@angular/material/icon';
import { FaqAnswerLevelComponent } from '../faq-answer-level/faq-answer-level.component';

@Component({
  selector: 'coin-siemens-energy-faq-inbetween-level',
  templateUrl: './faq-inbetween-level.component.html',
  styleUrls: ['./faq-inbetween-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, MatBadge, MatIcon, FaqAnswerLevelComponent]
})
export class FaqInbetweenLevelComponent implements OnInit {
  private readonly authService = inject(AuthService);

  @Input() items: FaqItem;
  @Output() openFaq = new EventEmitter<FaqDrill>();

  private readonly isAuthenticated = signal(false);

  async ngOnInit(): Promise<void> {
    this.isAuthenticated.set(this.authService.isAuthenticated$.value);
  }

  public openFaqItem(content: FaqItem, level: number, moreWidth = false, title?: boolean, subtitle?: string): void {
    this.openFaq.emit({ content, level, moreWidth, title, subtitle });
  }

  public authRequired(item: FaqItem): boolean {
    return item.requiresAuthentication ? this.isAuthenticated() : true;
  }
}
